import swipe from "bootstrap/js/src/util/swipe";
import {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";

/**
 * FormRouteStatus is a functional component that is responsible for rendering
 * information or UI based on the current status passed to it.
 *
 * @param {string} stat - A string representing the current status to be
 *                              displayed or used within the component.
 *                        r - Read Only
 *                        w - Modify Route
 *                        c - Create route
 *
 * @returns {JSX.Element} The JSX element representing the rendered output
 *                        of the component based on the status.
 */
const FormRouteStatus = ({stat}) => {
    const [status, setStatus] = useState(stat);
    const {t: _Tc} = useTranslation("choices");
    const handleStatus = (stat) => {
        switch (stat) {
            case "r":
                setStatus(<p className="text-warning m-0"><FontAwesomeIcon icon="ban"/> {_Tc("actions.ro")}</p>);
                break;
            case "w":
                setStatus(<p className="text-primary m-0"><FontAwesomeIcon icon="pen"/> {_Tc("actions.mo")}</p>);
                break;
            case "c":
                setStatus(<p className="text-success m-0"><FontAwesomeIcon icon="pen"/> {_Tc("actions.cr")}</p>);
                break;
            default:
                setStatus(<p>{_Tc("alerts_types.no")}</p>);
        }
    }
    useEffect(() => {
        handleStatus(stat)
    }, [stat])

    return (status)
}
export default FormRouteStatus;
